import React, { useState, useEffect } from "react";
import { SingleDropdownListWithoutSearch } from "../../../Common/Components/SingleDropdownListWithoutSearch";
import moment from "moment";

interface DateRangeProps {
  onAccountingPeriodRangeChange: (accountingPeriodStart: string | null, accountingPeriodEnd: string | null) => void;
}

const AccountingPeriodRange: React.FC<DateRangeProps> = ({ onAccountingPeriodRangeChange }) => {
  const [accountingPeriodStart, setAccountingPeriodStart] = useState<string>("");
  const [accountingPeriodEnd, setAccountingPeriodEnd] = useState<string>("");
  const [accountingPeriodStartList, setAccountingPeriodStartList] = useState<any[]>([]);
  const [accountingPeriodEndList, setAccountingPeriodEndList] = useState<any[]>([]);

  useEffect(() => {
    const startList: any[] = [];
    const endList: any[] = [];

    let currentDate = moment().add(1, "years").startOf("year"); // Start from January, 1 year ahead
    let lastDate = moment().subtract(2, "years").startOf("year"); // End at January, 2 years ago

    while (currentDate.isAfter(lastDate) || currentDate.isSame(lastDate, "month")) {
      startList.push({
        id: currentDate.format("MM/01/YY"), // First day of the month
        name: currentDate.format("MM/01/YY"),
      });

      endList.push({
        id: currentDate.endOf("month").format("MM/DD/YY"), // Last day of the month
        name: currentDate.endOf("month").format("MM/DD/YY"),
      });

      currentDate.subtract(1, "month").startOf("month"); // Move to previous month
    }

    // From dropdown: ascending order (oldest first)
    startList.reverse();
    // To dropdown: descending order (newest first) - keep as is

    // const firstDay = moment().startOf("year").format("MM/01/YY"); // January 1st of current year
    const lastDay = moment().endOf("month").format("MM/DD/YY"); // End of current month
    const firstDay = moment().endOf("month").format("MM/01/YY"); // End of current month

    setAccountingPeriodStart(firstDay);
    setAccountingPeriodEnd(lastDay);
    setAccountingPeriodStartList(startList);
    setAccountingPeriodEndList(endList);
  }, []);

  const handleSelectedStartItem = (id: string) => {
     const endOfMonth = moment(id, "MM/DD/YY")
    .endOf("month")
    .format("MM/DD/YY");

    setAccountingPeriodStart(id);
    setAccountingPeriodEnd(endOfMonth);

    onAccountingPeriodRangeChange(id, endOfMonth);
  };

  const handleSelectedEndItem = (id: string) => {
    setAccountingPeriodEnd(id);
    onAccountingPeriodRangeChange(accountingPeriodStart, id);
  };

  return (
    <>
      <label className="font-semibold mb-2 block">Accounting Period</label>
      {accountingPeriodStartList.length > 0 && accountingPeriodEndList.length > 0 && (
        <div className="flex flex-col md:flex-row gap-4 w-full">
          {/* Start Date Dropdown */}
          <div className="w-full">
            <SingleDropdownListWithoutSearch
              tabIndex={1}
              itemList={accountingPeriodStartList}
              handleSelectedItem={handleSelectedStartItem}
              defaultItem={accountingPeriodStart}
              defaultName={accountingPeriodStart}
              isAccountingPeriod={true}
              controlID="1"
              disabled={false}
              id="ddlAccountingStart"
            />
          </div>
          <span className="font-semibold mt-1">-</span>
          {/* End Date Dropdown */}
          <div className="w-full">
            <SingleDropdownListWithoutSearch
              tabIndex={2}
              itemList={accountingPeriodEndList}
              handleSelectedItem={handleSelectedEndItem}
              defaultItem={accountingPeriodEnd}
              defaultName={accountingPeriodEnd}
              isAccountingPeriod={true}
              controlID="2"
              disabled={false}
              id="ddlAccountingEnd"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AccountingPeriodRange;
